import { Attribute as AttributeApiType } from "api/types/attribute";
import { SiteSurveyUnitAttribute } from "api/types/siteSurveyUnitAttribute";
import { RadioGroup } from "../unit/RadioGroup";
import { TextAttribute } from "../unit/TextAttribute";
import { Photo } from "api/types/photo";
import { PhotoPreviewUpload } from "../PhotoPreviewUpload";
import { PhotoType } from "api/types/photoType";
import { SurveyFormContainer } from "../SurveyFormContainer";

interface AttributeType {
  attributeConfig: AttributeApiType;
  attributeValue?: SiteSurveyUnitAttribute;
  onAttributeValueChange: (attributeValueText: string) => void;
  onPhotoChange: (photo: Photo) => void;
  onDeletePhoto: () => void;
}

export function Attribute({
  attributeConfig,
  attributeValue,
  onAttributeValueChange,
  onPhotoChange,
  onDeletePhoto,
}: AttributeType) {
  const componentType =
    attributeConfig.choices.length > 0 ? "multiple-choice" : "text";

  const showPhotoSection =
    attributeConfig.photo && shouldShowPhoto(attributeConfig, attributeValue);

  if (attributeConfig.hidden) {
    return null;
  }
  return (
    <Container useContainer={showPhotoSection}>
      {componentType === "text" && (
        <TextAttribute
          attributeConfig={attributeConfig}
          attributeValue={attributeValue}
          onAttributeValueChange={onAttributeValueChange}
        />
      )}
      {componentType === "multiple-choice" && (
        <RadioGroup
          attributeConfig={attributeConfig}
          attributeValue={attributeValue}
          onAttributeValueChange={onAttributeValueChange}
        />
      )}

      {showPhotoSection && (
        <div className="row">
          <div className="col-sm-6">
            <PhotoPreviewUpload
              onChange={onPhotoChange}
              //We are already checking the attributeConfig.photo !== null inside shouldShowPhot
              photoType={attributeConfig.photo as PhotoType}
              photo={attributeValue?.photo ?? undefined}
              onDelete={onDeletePhoto}
            />
          </div>
        </div>
      )}
    </Container>
  );
}

function Container({ useContainer, children }) {
  if (useContainer) {
    return (
      <SurveyFormContainer className="px-2 pb-2 mt-2">
        {children}
      </SurveyFormContainer>
    );
  } else {
    return <div>{children}</div>;
  }
}

function shouldShowPhoto(
  attributeConfig: AttributeApiType,
  attribute?: SiteSurveyUnitAttribute
) {
  if (!attribute?.attributeValue) {
    return false;
  }

  for (let index = 0; index < attributeConfig.choices.length; index++) {
    const choice = attributeConfig.choices[index];
    if (choice.photoRequired && choice.text === attribute.attributeValue) {
      return true;
    }
  }

  return false;
}
